import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "1865aee9-9136-47e6-96ba-06f1d9ba3395",
  publicId: "10",
  name: "Radiosity methods",
  difficulty: 2,
  contentTypes: { audio: false, interactive: true, video: false },
  body: [principle01, task01, task02],
};

export default lesson;
